import {
  AssistantProfile,
  Message,
  MessageType,
  StoredChat,
} from "../../../../../../../lib/chat-store/types";
import AssistantBubble from "./bubbles/assistant-bubble";
import EventBubble from "./bubbles/event-bubble";
import ListingBubble from "./bubbles/listing-bubble";
import MediaBubble from "./bubbles/media-bubble";
import TextBubble from "./bubbles/text-bubble";

export default function ChatBubble({
  message,
  test_image_url,
  chatData,
}: {
  message: Message;
  test_image_url: string;
  chatData: StoredChat | undefined;
}) {
  switch (message.type) {
    case MessageType.LISTING:
      return (
        <ListingBubble
          {...message}
          receiverCompleteName={chatData?.receiver_complete_name}
          receiverPhotoUrl={chatData?.receiver_photo_url}
        />
      );
    case MessageType.TEXT:
      return (
        <TextBubble
          {...message}
          receiverCompleteName={chatData?.receiver_complete_name}
          receiverPhotoUrl={chatData?.receiver_photo_url}
        />
      );
    case MessageType.MEDIA:
      return (
        <MediaBubble
          {...message}
          receiverCompleteName={chatData?.receiver_complete_name}
          receiverPhotoUrl={chatData?.receiver_photo_url}
        />
      );
    case MessageType.EVENT:
      return (
        <EventBubble
          {...message}
          receiverCompleteName={chatData?.receiver_complete_name}
          receiverPhotoUrl={chatData?.receiver_photo_url}
        />
      );
    case MessageType.ASSISTANT:
      return <AssistantBubble chatData={chatData} {...message} />;
  }
}
